import React from "react";

const POFooterActions = ({
  onClose,
  onSubmit,
  saving
}) => {
  return (
    <div
      style={{
        padding: 12,
        borderTop: "1px solid #ddd",
        textAlign: "right",
      }}
    >
      <button
        className="btn btn-secondary me-2"
        onClick={onClose}
      >
        Cancel
      </button>

      <button
        className="btn btn-primary"
        disabled={saving}
        onClick={onSubmit}
      >
        {saving ? "Saving..." : "Save PO"}
      </button>
    </div>
  );
};

export default POFooterActions;
